import { apiClient } from '@/shared/api/client';
import type {
  RefereeQuestion,
  CreateRefereeQuestionRequest,
  UpdateRefereeQuestionRequest,
} from '../types/referee-question.types';
import type { ApiResponse } from '@/shared/types/api.types';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

async function request<T>(endpoint: string, method: HttpMethod, body?: unknown): Promise<T> {
  const response = await apiClient<ApiResponse<T>>(endpoint, { method, body });
  return response.data;
}

const SYSTEM_QUESTIONS_PATH = '/settings/referee-questions';

function companyQuestionsPath(companyId: string): string {
  return `/companies/${companyId}/settings/referee-questions`;
}

export const refereeQuestionService = {
  // System Questions (SUPER_ADMIN)
  listSystemQuestions: () => request<RefereeQuestion[]>(SYSTEM_QUESTIONS_PATH, 'GET'),

  createSystemQuestion: (data: CreateRefereeQuestionRequest) =>
    request<RefereeQuestion>(SYSTEM_QUESTIONS_PATH, 'POST', data),

  updateSystemQuestion: (questionId: string, data: UpdateRefereeQuestionRequest) =>
    request<RefereeQuestion>(`${SYSTEM_QUESTIONS_PATH}/${questionId}`, 'PUT', data),

  deleteSystemQuestion: (questionId: string) =>
    request<void>(`${SYSTEM_QUESTIONS_PATH}/${questionId}`, 'DELETE'),

  // Company Questions (ADMIN)
  listCompanyQuestions: (companyId: string) =>
    request<RefereeQuestion[]>(companyQuestionsPath(companyId), 'GET'),

  createCompanyQuestion: (companyId: string, data: CreateRefereeQuestionRequest) =>
    request<RefereeQuestion>(companyQuestionsPath(companyId), 'POST', data),

  updateCompanyQuestion: (
    companyId: string,
    questionId: string,
    data: UpdateRefereeQuestionRequest
  ) => request<RefereeQuestion>(`${companyQuestionsPath(companyId)}/${questionId}`, 'PUT', data),

  deleteCompanyQuestion: (companyId: string, questionId: string) =>
    request<void>(`${companyQuestionsPath(companyId)}/${questionId}`, 'DELETE'),
};
